/* eslint-disable react/prop-types */
import React, { useState, useCallback, useRef, useContext, useEffect, Suspense } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";

import { Button, Menu, MenuItem } from "@material-ui/core";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { VEBBenefitDetailsProps } from "../../../../../../../../../../@types/components/benefitsProps.types";
import { CellValueChangedEvent, ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";
import { Enrollment, VEBEnrollment } from "../../../../../../../../../../@types/enrollment.types";
import {
	handleDateCellRenderer,
	handleDollarCellRenderer
} from "../../../../../../../../../../utils/commonFunctions/cellRenderers";
import getAgGridHeight from "../../../../../../../../../../utils/commonFunctions/getAgGridHeight";
import {
	dateConverterToUSFormat,
	dateTimeZoneConverter
} from "../../../../../../../../../../utils/commonFunctions/date";
import { api } from "../../../../../../../../../../utils/api";
import { Validation } from "../../../../../../../../../../@types/validation.types";
import { DEPENDENT_BENEFIT_TERM_REASONS } from "../../../../../../../../../../constants/termReasons";
import CustomBenefitEndDialog from "../../../../../../../../../shared/dialogs/customBenefitEndDialog/CustomBenefitEndDialog";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { trackPromise } from "react-promise-tracker";
import { BsInfoCircle } from "react-icons/bs";
import { dollarize } from "../../../../../../../../../../utils/commonFunctions/dollar";
import { Paper, Popover, Typography } from "@mui/material";
import { formatTwoDecimalPlaces } from "../../../../../../../../../../constants/decimal";
import { VEB_PLAN_NAMES } from "../../../../../../../../../../constants/planNames";

const ITEM_HEIGHT = 48;

interface DataType {
	enrollments: Enrollment[];
	[key: string]: any;
}

interface HandleViewTotalBenefitCellRendererParams {
	value: number | null | undefined;
	node: {
		data: DataType;
	};
}

interface Props {
	handleSeeTotalBenefitDetailsButtonClick: (event: React.MouseEvent<SVGElement, MouseEvent>, data: DataType) => void;
}

const DependentVEBBenefitDetailsGrid = ({ benefits, benefitType }: VEBBenefitDetailsProps) => {
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	// const [anchorEl, setAnchorEl] = useState<(EventTarget & HTMLButtonElement) | null>(null);
	const [riderAnchorEl, setRiderAnchorEl] = useState<(EventTarget & HTMLButtonElement) | null>(null);
	const [gridHeight, setGridHeight] = useState<string>("300px");
	const [currentRider, setCurrentRider] = useState<VEBEnrollment[]>([]);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);

	const [riderAnchorEl2, setRiderAnchorEl2] = useState(null);

	const [benefitDetailsAnchorEl2, setBenefitDetailsAnchorEl2] = useState<Element | null>(null);

	const [totalBenefitAmountDetails, setTotalBenefitAmountDetails] = useState<any>({});

	const agGridRef = useRef<any>(null);

	const [termDetails, setTermDetails] = useState<any>({
		termination_date: "",
		termination_reason: ""
	});

	const [termValidation, setTermValidation] = useState<Validation>({
		termDetails: {},
		status: "invalid"
	});

	const [customTermDateReasonDialogProps, setCustomTermDateReasonDialogProps] = useState<any>({
		openDialog: false,
		title: "Do you want to end this dependent benefit?",
		content:
			"If yes, then this dependent will be removed from the benefit and recalculation of benefit will occur.",
		inputFields: [
			{
				label: "Benefit End Date",
				placeholder: "Enter Benefit End Date",
				name: "termination_date",
				value: termDetails.termination_date,
				type: "date"
			},
			{
				label: "Benefit Term Reason",
				placeholder: "Enter Benefit Termination Reason",
				name: "termination_reason",
				value: termDetails.termination_reason,
				type: "select",
				options: DEPENDENT_BENEFIT_TERM_REASONS
			}
		],
		actions: [
			{
				label: "Cancel",
				name: "cancel",
				callback: () => {
					handleCloseCustomTermDateReasonDialogClick();
				}
			},
			{
				label: "Submit",
				name: "submit",
				callback: () => null
			}
		]
	});

	const _termValidation = useRef<Validation>();

	const handleCloseCustomTermDateReasonDialogClick = useCallback(() => {
		const _termDetails = {
			termination_date: null,
			termination_reason: ""
		};
		setTermDetails(Object.assign({}, _termDetails));

		_termValidation.current = {
			termDetails: {
				termination_reason: "",
				termination_date: ""
			},
			status: "valid"
		};
		setTermValidation(Object.assign({}, _termValidation.current));

		setCustomTermDateReasonDialogProps(Object.assign({}, customTermDateReasonDialogProps, { openDialog: false }));
	}, [customTermDateReasonDialogProps]);

	const handleAgGridReady = (params: GridReadyEvent) => {
		const { api, columnApi } = params;
		setAgGridAPI(Object.assign({}, agGridAPI, api));
		setAgGridColumnAPI(columnApi);
	};

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
		const { api, columnApi } = params;
		api.sizeColumnsToFit();
	};

	const handleBenefitStatusCellRenderer = useCallback(() => {
		return <div>{benefitType}</div>;
	}, [benefitType]);

	const handleRiderDisplayClose = () => {
		setRiderAnchorEl(null);
	};

	const handleBenefitDetailsDisplayClose = () => {
		setBenefitDetailsAnchorEl2(null);
		// setOpenMenu(false);
	};

	// Button Click Handler
	const handleSeeTotalBenefitDetailsButtonClick = useCallback(
		async (event: React.MouseEvent<SVGElement, MouseEvent>, data: DataType | any) => {
			event.stopPropagation();
			console.log("object", data);
			setBenefitDetailsAnchorEl2(event.currentTarget);

			const details: any = {
				base: {},
				stacked: []
			};

			// const currentActiveEnrollment = [...data.enrollments].sort(
			// 	(a, b) => new Date(b.enrollment_date).getTime() - new Date(a.enrollment_date).getTime()
			// )[0];

			if (data?.stacked_enrollments?.length > 0) {
				const [baseEnrollment, ...stacked] = data.stacked_enrollments;

				details.base = {
					benefit_amount: baseEnrollment.benefit_amount,
					enrollment_date: baseEnrollment.enrollment_date,
					total_premium: baseEnrollment.total_premium
				};

				details.stacked = stacked.map((enrollment: any) => ({
					benefit_amount: enrollment.benefit_amount,
					enrollment_date: enrollment.enrollment_date,
					total_premium: enrollment.total_premium
				}));
			} else {
				// console.log("running");
				details.base = {
					benefit_amount: data.benefit_amount,
					enrollment_date: data.enrollment_date,
					total_premium: data.total_premium
				};
			}

			setTotalBenefitAmountDetails(details);
		},
		[setTotalBenefitAmountDetails]
	);
	// Cell Renderer
	const handleViewTotalBenefitCellRenderer = useCallback(
		({ value, node }: HandleViewTotalBenefitCellRendererParams) => {
			if (!value) return <></>;

			const data = node.data;

			const handleButtonClick = (event: React.MouseEvent<SVGElement, MouseEvent>) => {
				handleSeeTotalBenefitDetailsButtonClick(event, data);
			};

			return (
				<div style={{ display: "flex", alignItems: "center" }}>
					<div style={{ marginRight: "5px", minWidth: "50px" }}>{dollarize(value)}</div>
					<BsInfoCircle style={{ cursor: "pointer", fontSize: "18px" }} onClick={handleButtonClick} />
				</div>
			);
		},
		[handleSeeTotalBenefitDetailsButtonClick]
	);

	const handleSeeRidersButtonClick = useCallback(async (event: React.MouseEvent<HTMLButtonElement>) => {
		// console.log("Anchorel", event.currentTarget);
		setRiderAnchorEl(event.currentTarget);
		const focusedCell = agGridRef?.current.api.getFocusedCell();
		const row = agGridRef?.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
		const { data } = row;
		const getRidersQuery = {
			insured_SSN: data.employee.SSN,
			base_plan_name: data.base_plan_name,
			effective_date: data.effective_date,
			group_number: data.employee.group_number
		};

		if (data.base_plan_name == VEB_PLAN_NAMES.whole_life) {
			const riders = await api.enrollments.getVEBRidersByPlan(getRidersQuery);

			const seen = new Set();
			const distinctRiders = riders.filter((rider: any) => {
				if (seen.has(rider.plan_name)) return false;
				seen.add(rider.plan_name);
				return true;
			});

			const ridersList = [];

			// const baseEnrollment = data.filter((enrollment: any) => enrollment.base_plan_name == enrollment.plan_name);

			if (Boolean(data)) {
				if (Boolean(data.accidental_death_chronic_illness)) {
					ridersList.push({
						plan_name: "Accidental Death Chronic Illness",
						premium_amount: data.accidental_death_chronic_illness
					});
				}
				if (Boolean(data.waiver_of_premium)) {
					ridersList.push({
						plan_name: "Waiver of Premium",
						premium_amount: data.waiver_of_premium
					});
				}
			}

			setCurrentRider(Object.assign([], [...distinctRiders, ...ridersList]));
		} else {
			const riders = await api.enrollments.getVEBRidersByPlan(getRidersQuery);
			setCurrentRider(Object.assign([], riders));
		}
		//setRiderAnchorEl(event.currentTarget);
	}, []);

	const handleViewRidersCellRenderer = useCallback(
		({ currentRider, riderAnchorEl }: { currentRider: any; riderAnchorEl: any }) => {
			return (
				<>
					<Button
						id={Math.random() + ""}
						onClick={handleSeeRidersButtonClick}
						className="ag-grid-cell-button"
					>
						See Details
					</Button>
					<Menu
						id="long-menu"
						anchorEl={riderAnchorEl}
						keepMounted
						open={Boolean(riderAnchorEl)}
						onClose={handleRiderDisplayClose}
						PaperProps={{
							style: {
								maxHeight: ITEM_HEIGHT * 4.5,
								width: "auto"
							}
						}}
					>
						{currentRider.length !== 0 ? (
							currentRider.map((rider: any, index: number) => {
								const { plan_name } = rider;
								return (
									<MenuItem key={index} onClick={handleRiderDisplayClose}>
										<div>{plan_name}</div>
									</MenuItem>
								);
							})
						) : (
							<MenuItem>
								<div className="no-riders">N/A</div>
							</MenuItem>
						)}
					</Menu>
				</>
			);
		},
		[handleSeeRidersButtonClick]
	);

	const handlePlanEndDateCellRenderer = ({ value }: { value: string }) => {
		return <div>{value ? dateConverterToUSFormat(value) : "CURRENT"}</div>;
	};

	const handleOpenTermChangeDialogClick = useCallback(() => {
		setCustomTermDateReasonDialogProps(Object.assign({}, customTermDateReasonDialogProps, { openDialog: true }));
	}, [customTermDateReasonDialogProps]);

	const handleDateChange = useCallback(
		(_date: MaterialUiPickersDate, name: string) => {
			const date = new Date(_date as Date);
			// // console.log(date, "setting Date ", name);
			const parsedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
			setTermDetails(Object.assign({}, termDetails, { [name]: parsedDate }));
		},
		[setTermDetails, termDetails]
	);

	const handleTermReasonChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			// // console.log(event.target.name, "setting term reason", event.target.value);
			const { value } = event.target;
			const { name } = event.target;
			setTermDetails(Object.assign({}, termDetails, { [name]: value }));
		},
		[setTermDetails, termDetails]
	);

	const handleTermValidation = useCallback(async () => {
		const { termination_date, termination_reason } = termDetails;

		const focusedCell = agGridRef.current.api.getFocusedCell();
		const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
		const {
			data: { effective_date }
		} = row;

		_termValidation.current = {
			...termValidation,
			termDetails: {},
			status: "invalid"
		};
		let flag = true;
		if (termination_reason.length === 0) {
			_termValidation.current.termDetails["termination_reason"] = "Benefit End Reason is required";
			_termValidation.current["status"] = "invalid";
			flag = false;
		}

		if (String(termination_date).length === 0) {
			_termValidation.current.termDetails["termination_date"] = "Benefit End Date is required";
			_termValidation.current["status"] = "invalid";
			flag = false;
		}
		// if (termination_date.length !== 0) {
		// 	if (manualDateComparator(effective_date, termination_date) === 1) {
		// 		_termValidation.current.termDetails["termination_date"] =
		// 			"Benefit End Date cannot be less than the Effective Date!";
		// 		_termValidation.current["status"] = "invalid";
		// 		flag = false;
		// 	}
		// }

		if (flag === true) _termValidation.current["status"] = "valid";
		else {
			_termValidation.current["status"] = "invalid";
			alert("Please, fill all required fields!");
		}
		setTermValidation(Object.assign({}, _termValidation.current));
		return _termValidation.current["status"];
	}, [termDetails, termValidation]);

	const handleBenefitChangeSubmitClick = useCallback(
		async (event: React.MouseEvent<HTMLButtonElement>) => {
			try {
				const benefitTermValidation = await handleTermValidation();
				if (benefitTermValidation === "valid") {
					// console.log("Benefit Term Inside");
					const { termination_date, termination_reason } = termDetails;

					const focusedCell = agGridRef.current.api.getFocusedCell();
					const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
					const {
						data: { plan_name, group_number, insured_SSN, member_SSN }
					} = row;
					const planName: any = [];
					planName.push(plan_name);

					const _benefitRecalculationPayload = {
						group_number,
						member_SSN,
						insured_SSN,
						termination_reason,
						termination_date,
						all_group_plans: false,
						all_VEB_plans: false,
						specific_group_plans: [],
						specific_VEB_plans: planName,
						recalculate_group_benefits: false,
						recalculate_VEB_benefits: true
					};
					// console.log("_benefitRecalculationPayload", _benefitRecalculationPayload);

					// alert("This Feature is coming shortly!");
					const response: any = await trackPromise(
						api.enrollments.benefitRecalculation(_benefitRecalculationPayload)
					);

					if (response) {
						alert(`Dependent is successfully terminated from ${plan_name} and benefit is recalculated!`);
						handleCloseCustomTermDateReasonDialogClick();
						window.location.reload();
					}
				}
			} catch (error) {
				alert("Dependent Termination Unsuccessful!");
				throw error;
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[handleTermValidation, termDetails]
	);

	const handleActionCellRender = useCallback(() => {
		return (
			<Button className="ag-grid-cell-button " variant="outlined" onClick={handleOpenTermChangeDialogClick}>
				Remove from Plan
			</Button>
		);
	}, [handleOpenTermChangeDialogClick]);

	useEffect(() => {
		if (termDetails.termination_date === null)
			setTermDetails(Object.assign({}, termDetails, { termination_date: "" }));
	}, [termDetails]);

	useEffect(() => {
		const _customTermDateReasonDialogProps = customTermDateReasonDialogProps;
		_customTermDateReasonDialogProps.inputFields[0].value = termDetails.termination_date;
		_customTermDateReasonDialogProps.inputFields[1].value = termDetails.termination_reason;

		setCustomTermDateReasonDialogProps(Object.assign({}, _customTermDateReasonDialogProps));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [termDetails]);

	useEffect(() => {
		const _gridHeight = getAgGridHeight(benefits.length);
		setGridHeight(_gridHeight);
	}, [benefits.length]);

	const columnStyle: React.CSSProperties = {
		fontSize: "13px",
		fontWeight: 600,
		color: "#333",
		padding: "8px",
		minWidth: "100px",
		textAlign: "left",
		overflowWrap: "break-word"
	};

	const cellStyle: React.CSSProperties = {
		fontSize: "14px",
		color: "#212121",
		padding: "10px 8px",
		overflowWrap: "break-word"
	};

	return (
		<>
			<Suspense fallback={<div />}>
				<CustomBenefitEndDialog
					dialogProps={customTermDateReasonDialogProps}
					handleDateChange={handleDateChange}
					handleTermReasonChange={handleTermReasonChange}
					termValidation={termValidation}
					handleClose={handleCloseCustomTermDateReasonDialogClick}
					handleTermEmployment={handleBenefitChangeSubmitClick}
				/>
			</Suspense>

			<div className="dependent-VEB-benefits-grid-container">
				<div className="VEB-benefits-grid-container glb-tab-grid-container">
					<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
						<AgGridReact
							ref={agGridRef}
							rowData={benefits}
							onGridReady={handleAgGridReady}
							onFirstDataRendered={handleFirstDataRendered}
							rowSelection={"Single"}
							animateRows
							suppressColumnVirtualisation={true}
							defaultColDef={{
								resizable: true,
								filter: "agTextColumnFilter",
								floatingFilter: true,
								floatingFilterComponentParams: { suppressFilterButton: true }
							}}
							onCellValueChanged={(params: CellValueChangedEvent) => {
								params.api.refreshCells({
									force: true,
									columns: ["active_family_member", "base_plan_name", "Riders"]
								});
							}}
							enableCellChangeFlash={true}
							frameworkComponents={{
								handleActionCellRender: handleActionCellRender,
								handleViewRidersCellRenderer: handleViewRidersCellRenderer,
								handleBenefitStatusCellRenderer: handleBenefitStatusCellRenderer,
								handleDateCellRenderer: handleDateCellRenderer,
								handleDollarCellRenderer: handleDollarCellRenderer,
								handlePlanEndDateCellRenderer: handlePlanEndDateCellRenderer,
								handleViewTotalBenefitCellRenderer: handleViewTotalBenefitCellRenderer
							}}
						>
							<AgGridColumn
								field="base_plan_name"
								headerName="Plan Name"
								suppressSizeToFit={true}
							></AgGridColumn>
							<AgGridColumn
								field="member.relationship"
								headerName="Relationship"
								suppressSizeToFit
							></AgGridColumn>
							<AgGridColumn
								field="enrollment_date"
								headerName="Enrollment Date"
								cellRenderer="handleDateCellRenderer"
							></AgGridColumn>
							<AgGridColumn
								field="effective_date"
								headerName="Effective Date"
								cellRenderer="handleDateCellRenderer"
							></AgGridColumn>
							<AgGridColumn
								// field="plan.end_date"
								field="termination_date"
								headerName="Benefit End Date"
								cellRenderer="handlePlanEndDateCellRenderer"
							></AgGridColumn>
							<AgGridColumn
								field="benefit_amount"
								headerName="Benefit Amount"
								floatingFilterComponentParams={{ suppressFilterButton: true }}
								// cellRenderer="handleDollarCellRenderer"
								cellRenderer="handleViewTotalBenefitCellRenderer"
								cellRendererParams={{
									riderAnchorEl2: riderAnchorEl2,
									currentRider: currentRider
								}}
								suppressSizeToFit={true}
							></AgGridColumn>
							<AgGridColumn
								field="base_plan_name"
								headerName="Riders"
								cellRenderer="handleViewRidersCellRenderer"
								cellRendererParams={{
									currentRider: currentRider,
									riderAnchorEl: riderAnchorEl
								}}
								suppressSizeToFit={true}
								filter={false}
							></AgGridColumn>
							{/* <AgGridColumn
								field="action"
								headerName="Action"
								cellRenderer="handleActionCellRender"
								filter={false}
								suppressSizeToFit={true}
							></AgGridColumn> */}
						</AgGridReact>

						<div className="plan-overall-main-container">
							<Popover
								open={Boolean(benefitDetailsAnchorEl2)}
								anchorEl={benefitDetailsAnchorEl2}
								onClose={handleBenefitDetailsDisplayClose}
								anchorOrigin={{ vertical: "center", horizontal: "left" }}
								transformOrigin={{ vertical: "center", horizontal: "left" }}
								PaperProps={{
									style: {
										width: "350px",
										padding: "1rem",
										marginLeft: "30px"
									}
								}}
							>
								<Paper style={{ boxShadow: "none" }}>
									<Typography variant="h6" fontWeight={700} color="#1a237e" gutterBottom>
										Benefits Overview
									</Typography>

									{/* Base Enrollment Table */}
									{totalBenefitAmountDetails?.base && (
										<div style={{ marginBottom: "1.5rem" }}>
											<Typography
												variant="subtitle2"
												fontWeight={600}
												color="#3949ab"
												style={{ fontSize: "15px", marginBottom: "0.5rem" }}
											>
												Base Enrollment
											</Typography>
											<div style={{ overflowX: "auto" }}>
												<table
													className="enrollment-table"
													style={{
														width: "100%",
														borderCollapse: "collapse",
														tableLayout: "fixed"
													}}
												>
													<thead>
														<tr style={{ backgroundColor: "#f5f5f5" }}>
															<th style={columnStyle}>Benefit Amount</th>
															<th style={columnStyle}>Enrollment Date</th>
															<th style={columnStyle}>Premium Amount</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td style={cellStyle}>
																$
																{formatTwoDecimalPlaces(
																	totalBenefitAmountDetails.base.benefit_amount
																)}
															</td>
															<td style={cellStyle}>
																{new Date(
																	dateTimeZoneConverter(
																		totalBenefitAmountDetails.base.enrollment_date
																	)
																).toLocaleDateString()}
															</td>
															<td style={cellStyle}>
																$
																{formatTwoDecimalPlaces(
																	totalBenefitAmountDetails.base.total_premium
																)}
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									)}

									{/* Stacked Enrollments Table */}
									{totalBenefitAmountDetails?.stacked?.length > 0 && (
										<div>
											<Typography
												variant="subtitle2"
												fontWeight={600}
												color="#5e35b1"
												style={{ fontSize: "15px", marginBottom: "0.5rem" }}
											>
												Stacked Enrollments
											</Typography>
											<div style={{ overflowX: "auto" }}>
												<table
													className="enrollment-table"
													style={{
														width: "100%",
														borderCollapse: "collapse",
														tableLayout: "fixed"
													}}
												>
													<thead>
														<tr style={{ backgroundColor: "#f5f5f5" }}>
															<th style={columnStyle}>Benefit Amount</th>
															<th style={columnStyle}>Enrollment Date</th>
															<th style={columnStyle}>Premium Amount</th>
														</tr>
													</thead>
													<tbody>
														{totalBenefitAmountDetails.stacked.map(
															(item: any, index: any) => (
																<tr key={`stacked-${index}`}>
																	<td style={cellStyle}>
																		${formatTwoDecimalPlaces(item.benefit_amount)}
																	</td>
																	<td style={cellStyle}>
																		{new Date(
																			dateTimeZoneConverter(item.enrollment_date)
																		).toLocaleDateString()}
																	</td>
																	<td style={cellStyle}>
																		${formatTwoDecimalPlaces(item.total_premium)}
																	</td>
																</tr>
															)
														)}
													</tbody>
												</table>
											</div>
										</div>
									)}
								</Paper>
							</Popover>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default DependentVEBBenefitDetailsGrid;
